// 判断当前元素是否出现在视口中
export const isElementNotInViewport = function(el) {
  // 获取元素滚动高度和浏览器可视区域高度
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
  const clientHeight = document.documentElement.clientHeight

  return(el.offsetTop+200 < scrollTop + clientHeight)
}

